import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ClientConfigClass;
function ClientConfig() {
  if (ClientConfigClass === VOID) {
    class $ {
      constructor(prereleaseMode, auth0ClientId, auth0Domain, basename, expressEnv, webpackPublicPath, websocketHost) {
        this.g7j_1 = prereleaseMode;
        this.h7j_1 = auth0ClientId;
        this.i7j_1 = auth0Domain;
        this.j7j_1 = basename;
        this.k7j_1 = expressEnv;
        this.l7j_1 = webpackPublicPath;
        this.m7j_1 = websocketHost;
      }
      toString() {
        return 'ClientConfig(prereleaseMode=' + this.g7j_1 + ', auth0ClientId=' + this.h7j_1 + ', auth0Domain=' + this.i7j_1 + ', basename=' + this.j7j_1 + ', expressEnv=' + this.k7j_1 + ', webpackPublicPath=' + this.l7j_1 + ', websocketHost=' + this.m7j_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.g7j_1);
        result = imul(result, 31) + getStringHashCode(this.h7j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i7j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j7j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.k7j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l7j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m7j_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConfig()))
          return false;
        if (!(this.g7j_1 === other.g7j_1))
          return false;
        if (!(this.h7j_1 === other.h7j_1))
          return false;
        if (!(this.i7j_1 === other.i7j_1))
          return false;
        if (!(this.j7j_1 === other.j7j_1))
          return false;
        if (!(this.k7j_1 === other.k7j_1))
          return false;
        if (!(this.l7j_1 === other.l7j_1))
          return false;
        if (!(this.m7j_1 === other.m7j_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConfig');
    ClientConfigClass = $;
  }
  return ClientConfigClass;
}
//region block: exports
export {
  ClientConfig as ClientConfig2mpft8d5d0hh3,
};
//endregion

//# sourceMappingURL=ClientConfig.mjs.map
